export const TOKEN_INVALID_OR_EXPIRED_MESSAGE = 'Token is invalid or expired';
export const ACCESS_REVOKED_MESSAGE = 'Access revoked';
